import { Controller } from "@hotwired/stimulus"

// Opens a native dialog. The form inside it is the confirm step.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }
}
